<mat-form-field subscriptSizing="dynamic">
  <mat-label>Straße</mat-label>
  <input
    type="text"
    [(ngModel)]="value"
    [required]="required() || pflicht()"
    (input)="markiereBeruehrt()"
    matInput
    [errorStateMatcher]="fehlerZustand"
    [matAutocomplete]="auto"
    autocomplete="off"
  />
  @if ((required() || pflicht()) && !value()?.trim()) {
    <mat-error>Bitte eintragen.</mat-error>
  }
  <mat-autocomplete #auto="matAutocomplete">
    @if (suggestions.isLoading()) {
      <mat-option disabled>Lädt Vorschläge...</mat-option>
    } @else if (suggestions.error()) {
      <mat-option disabled>Fehler beim Laden</mat-option>
    } @else {
      @for (suggestion of suggestions.value(); track $index) {
        <mat-option [value]="suggestion.street ?? ''" (onSelectionChange)="applyAutocompleteSelection(suggestion)">
          {{ label(suggestion) }}
        </mat-option>
      } @empty {
        @if (value()) {
          <mat-option disabled>Keine Vorschläge gefunden</mat-option>
        }
      }
    }
  </mat-autocomplete>
</mat-form-field>
